<template>
  <q-card v-if="items && items.length>0">
    <q-card-section>
      <q-list>
        <q-item-label header class="text-bold">لیست پرسشنامه های طرف معامله</q-item-label>

        <q-item v-for="(item,index) in items" :key="index">
          <q-item-section side>
            <div class="text-grey-8">
              <q-btn size="12px" flat dense round icon="edit" color="indigo">
                <q-popup-edit v-model="item.Title" :validate="val => val.length > 5">
                  <template v-slot="scope">
                    <q-input
                        autofocus
                        dense
                        v-model="scope.value"
                        hint="عنوان جدید را وارد نمایید"
                        :rules="[val => scope.validate(val) || 'More than 5 chars required']"
                    >
                      <template v-slot:after>
                        <q-btn
                            round
                            flat dense color="negative" icon="cancel"
                            @click.stop="scope.cancel"
                        />

                        <q-btn
                            round
                            flat dense color="positive" icon="check_circle"
                            @click.stop="scope.set"
                            @click="updateQuestion(item)"
                            :disable="scope.validate(scope.value) === false || scope.initialValue === scope.value"
                        />
                      </template>
                    </q-input>
                  </template>
                </q-popup-edit>
              </q-btn>
              <q-btn size="12px" flat dense round icon="delete" color="red"
                     @click="deleteItem(index, item)"/>
              <q-btn size="12px" flat dense round icon="settings" color="indigo" @click="selectingQuestion(item)"/>
            </div>
          </q-item-section>
          <q-item-section>
            <q-item-label class="q-mt-sm">
              {{ item.Title }}
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
    <q-dialog maximized v-model="questionsListDialog">
      <Questions :question-info="selectedQuestionInfo" />
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import Questions from "@/components/CustomerQuestions/Questions";

export default {
  name: "QuestionnaireList",
  components: {Questions},
  props: {
    items: []
  },
  data() {
    return {
      questionsListDialog:false,
      selectedQuestionInfo:undefined,
    }
  },
  methods: {
    ...mapActions({
      questionCRUD: 'Questions/crudQuestion'
    }),
    selectingQuestion(item){
      this.selectedQuestionInfo = item
      this.questionsListDialog = true
    },
    updateQuestion(item) {
      this.questionCRUD({
        action: 'update',
        id: item.ID,
        title: item.Title
      })
    },
    deleteItem(index, row) {
      this.$q.dialog({
        title: 'تاییدیه',
        message: 'پرسشنامه حذف شود؟',
        persistent: true,
        ok: {
          label: 'بلی'
        },
        cancel: {
          label: 'خیر',
          color: 'negative'
        },
      }).onOk(() => {
        this.questionCRUD({
          action: 'delete',
          id: row.ID
        }).then(() => {
          this.$delete(this.items, index)
        })
      })
    }
  }
}
</script>

<style scoped>

</style>